import React from "react"
import ModalWindow from "../ModalWindow"
import PropTypes from "prop-types"
import "./ExcludedAreas.scss"
import ExcludedAreasTableWithData from "./ExcludedAreasTableWithData"

const ExcludedAreas = props => {
  return (
    <ModalWindow isOpen={props.modalOpen} onRequestClose={props.onClose}>
      <div className="ExcludedAreas">
        <h1 className="title">Excluded Areas</h1>
        <p>
          The following areas have been excluded from compliance monitoring due
          to temporary construction, inadequate room layout or insufficient
          outlet availability. Visits to these rooms are not scored for
          compliance, and will not appear in the dashboard.
        </p>
        <div className="table-wrapper">
          <ExcludedAreasTableWithData />
        </div>
      </div>
    </ModalWindow>
  )
}

ExcludedAreas.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default ExcludedAreas
